module.exports = __webpack_public_path__ + "img/exam.f1549fac.png";